import { render, staticRenderFns } from "./Breadcrumb.htm?vue&type=template&id=2016ba8e&scoped=true&external"
import script from "./Breadcrumb.js?vue&type=script&lang=js&external"
export * from "./Breadcrumb.js?vue&type=script&lang=js&external"
import style0 from "./Breadcrumb.scss?vue&type=style&index=0&id=2016ba8e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016ba8e",
  null
  
)

export default component.exports